import type { QuoteDocument } from 'paintscout'
import { getPayments } from './get-payments'

export function hasProcessingPayment(args: { quote: QuoteDocument }): boolean {
  return getPayments(args).some((p) => p.status === 'processing')
}
